/**
 * WebMCP — Browser Model Context Protocol provider.
 * Exposes LimeShare capabilities to on-device AI agents (Chrome Gemini, agent extensions)
 * via navigator.modelContext / window.modelContext.
 */

declare global {
  interface Window {
    modelContext?: {
      provideContext?: (ctx: unknown) => void;
      tools?: unknown[];
    };
  }
}

export function registerWebMcp(): void {
  if (typeof window === "undefined") return;

  const tools = [
    {
      name: "limeshare_get_limits",
      description: "Get maximum file transfer size limits and retention rules for LimeShare",
      inputSchema: { type: "object", properties: {} },
      execute: async () => {
        const res = await fetch("https://api.limeshare.org/v1/limits");
        return res.json();
      },
    },
    {
      name: "limeshare_verify_receipt",
      description: "Verify an Ed25519 Certified Destruction receipt proving that files were purged from storage",
      inputSchema: {
        type: "object",
        properties: {
          transferId: { type: "string" },
          signature: { type: "string" },
        },
        required: ["transferId", "signature"],
      },
      execute: async ({ transferId, signature }: { transferId: string; signature: string }) => {
        const res = await fetch(`https://api.limeshare.org/v1/transfers/${encodeURIComponent(transferId)}/receipt?sig=${encodeURIComponent(signature)}`);
        return res.json();
      },
    },
  ];

  window.modelContext = window.modelContext || {};
  window.modelContext.tools = tools;

  const nav = navigator as unknown as { modelContext?: { provideContext: (c: unknown) => void } };
  if (nav.modelContext && typeof nav.modelContext.provideContext === "function") {
    try {
      nav.modelContext.provideContext({
        name: "limeshare",
        version: "1.0.0",
        tools,
      });
    } catch {
      /* ignore */
    }
  }
}
